module.exports = __webpack_public_path__ + "media/images/pic/parowki-7257e584dd97abdf06adeadcf15d025c.jpg";